import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
// const options = {role: ROLE.SUPER_ADMIN};
const options = {};

const path = "admin/notifications"

export const SendPushNotification = async (values) => {
    return await axiosInstance(options).post(`${path}/send-push-notification`, values);
}

export const SendInAppNotification = async (values) => {
    return await axiosInstance(options).post(`${path}/send-in-app-notification`, values);
}

// export const AboutUsDetails = async (id) => {
//     return await axiosInstance(options).get(`${path}/create-campaign`);
// }



